import axios from "axios";

const baseUrl = process.env.REACT_APP_BASE_URL;

const API_URL_GET_USERS = baseUrl + "/api/v1/admin/list";

const API_URL_ADD_USER = baseUrl + "/api/v1/admin/add";

const API_URL_EDIT_USER = baseUrl + "/api/v1/admin/edit";

const API_URL_DELETE_USER = baseUrl + "/api/v1/admin/delete";

//   Get User
const getUsers = async (token) => {
  const config = {
    headers: {
      Authorization: token,
    },
  };
  const res = await axios.get(API_URL_GET_USERS, config);
  const newToken = res.headers.authorization;
  return { res, newToken };
};

// Add User
const addUser = async (data, token) => {
  const config = {
    headers: {
      Authorization: token,
    },
  };
  const res = await axios.post(API_URL_ADD_USER, data, config);
  const newToken = res.headers.authorization;
  return { res, newToken };
};

// Edit User
const updateUser = async (data, token) => {
  const config = {
    headers: {
      Authorization: token,
    },
  };
  const res = await axios.put(API_URL_EDIT_USER, data, config);
  const newToken = res.headers.authorization;
  return { res, newToken };
};

//   Delete User
const deleteUser = async (data, token) => {
  const config = {
    headers: {
      Authorization: token,
    },
    data: data,
  };
  const res = await axios.delete(API_URL_DELETE_USER, config);
  const newToken = res.headers.authorization;
  return { res, newToken };
};

const userService = {
  getUsers,
  addUser,
  updateUser,
  deleteUser,
};

export default userService;
